/* eslint-disable import/prefer-default-export */
const CookieConsentService = {
  getCookieConsentAccepted() {
    return localStorage.getItem('cookieConsentAccepted');
  },
  saveCookieConsentAccepted(value) {
    localStorage.setItem('cookieConsentAccepted', value);
  },
  getCookieConsentProcessed() {
    return localStorage.getItem('cookieConsentProcessed');
  },
  saveCookieConsentProcessed(value) {
    localStorage.setItem('cookieConsentProcessed', value);
  },
};

export {
  CookieConsentService,
};
